import React from 'react'
import { appConfig, themeConfig } from 'config'
import { Button } from 'antd'
import { QRCode } from 'react-qrcode-logo'
import styled from 'styled-components'
import { DownloadOutlined } from '@ant-design/icons'
import BaandyLogo from '../../assets/img/logo-qr.png'
import PuiyaLogo from '../../assets/img/puiya-logo-qr.png'

type Props = {
  merchantID: number
  title: string
  width?: number
}

const MerchantQrCode = (props: Props) => {
  const { title = '', width = 150, merchantID } = props
  const Logo = themeConfig.title.appName === 'Baandy' ? BaandyLogo : PuiyaLogo

  const qrCodeVal = `${appConfig.publicFrontEndpoint}merchant-products/${merchantID}`

  const downloadQR = () => {
    const canvas = document.getElementById('react-qrcode-logo') as HTMLCanvasElement
    const img = canvas && canvas.toDataURL('image/png')
    const link = document.createElement('a')
    link.download = `${title}-QRcode.png`
    link.href = img
    link.click()
  }

  return (
    <QrWrapper>
      <HiddenQr className="qr-download">
        <QRCode size={500} value={qrCodeVal} logoImage={Logo} logoWidth={500 * 0.4} ecLevel="H" />
      </HiddenQr>
      <QRCode size={width} value={qrCodeVal} logoImage={Logo} logoWidth={width * 0.4} ecLevel="H" />
      <DownloadTxt>
        <Button type="dashed" onClick={downloadQR} icon={<DownloadOutlined />} size={'middle'}>
          ดาวน์โหลด
        </Button>
      </DownloadTxt>
    </QrWrapper>
  )
}

const QrWrapper = styled.div``

const HiddenQr = styled.div`
  display: none;
`

const DownloadTxt = styled.div`
  margin-left: 10px;
  .ant-btn {
    font-size: 12px;
  }
`

export default MerchantQrCode
